const state = {
  currentBusinessAccount: null,
  listBank: [],
  listMomo: [],
  listBankAccount: [],
  listMomoAccount: [],
  listTransfer: [],
  totalTransfer: 0,
  listTopUp: [],
  listTransaction: [],
  totalTransaction: 0,
  listAllTransaction: [],
  availableBalance: null,
  listOutgoing: [],
  listIncoming: [],
  listVisaCards: []

}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/e-wallet/state.js